// import { ComentarioModel } from './ws-comentario';

export interface ITicketWeb {
    IdTicketWeb: number;
    IdTicket: number;
    CodeGeneratedSS: string;
    FechaRegistro: Date | null;
    Asunto: string;
    Departamento: string;
    IdEstadoTW: number;
    IdEstadoTicket: number;
    EstadoTicket: string;
    PersonalAsignado: string;
}

export class TicketWebModel {
    public IdTicketWeb: number;
    public IdTicket: number;
    public CodeGeneratedSS: string;
    public FechaRegistro: Date | null;
    public Asunto: string;
    public Departamento: string;
    public IdEstadoTW: number;
    public IdEstadoTicket: number;
    public EstadoTicket: string;
    public PersonalAsignado: string;

    constructor(data?: ITicketWeb) {
        if (data) {
            this.IdTicketWeb = data.IdTicketWeb;
            this.IdTicket = data.IdTicket;
            this.CodeGeneratedSS = data.CodeGeneratedSS;
            this.FechaRegistro = data.FechaRegistro;
            this.Asunto = data.Asunto;
            this.Departamento = data.Departamento;
            this.IdEstadoTW = data.IdEstadoTW;
            this.IdEstadoTicket = data.IdEstadoTicket;
            this.EstadoTicket = data.EstadoTicket;
            this.PersonalAsignado = data.PersonalAsignado;
        }
    }
}

export class TicketWebModelById{
    public IdTicketWeb: number;
    public CodeGeneratedSS: string;
    public Asunto: string;
    public NroSerie: string;
    public Incidencia: string;
    public ContactoSolicitante: string;
    public Contactos: [];

    constructor(data: any) {
        if (data) {
            this.IdTicketWeb = data.IdTicketWeb;
            this.CodeGeneratedSS = data.CodeGeneratedSS;
            this.Asunto = data.Asunto;
            this.NroSerie = data.NroSerie;
            this.Incidencia = data.Incidencia;
            this.ContactoSolicitante = data.ContactoSolicitante;
            this.Contactos = data.Contactos;
        }
    }
}

/* individual */
// export class TicketByIDModel {
//     IdTicket: number;
//     TipoIngreso: number;
//     IdEstado: number;
//     IdLinea: number;
//     LineaNegocioAbreviado: string;
//     IdPrioridad: number;
//     Asunto: string;
//     IdCliente: number;
//     // ClienteNumDoc: string;
//     // ClienteCodCipsa: string;
//     // RazonSocial: string;
//     // IdContacto: number;
//     // TipoContacto: string;
//     // Nombre: string;
//     // Cargo: string;
//     // Area: string;
//     // Email: string;
//     // Telf: string;
//     // Anexo: string;
//     IdPersonalDerivado: number;
//     PersonalDerivado: string;
//     PerDerivadoPuesto: string;
//     TiempoTranscurrido: number;
//     // IdPersonalSolicitante: number;
//     // PersonalSolicitante: string;
//     // ProximaAlerta: string;
//     // AnotacionInterna: string;
//     // IdBolsaTiempo: number;
//     // Horas: number;
//     // TiempoEfectivo: number;
//     // VigenciaFin: string;
//     // Motivo: string;
//     // Factura: string;
//     // IdPersonalRegistro: number;
//     // PersonalRegistro: string;
//     FechaRegistro: string;
//     FlagRequerimiento: boolean;
//     Calificacion: number;
//     CalificacionObs: string;

//     // Listas
//     Contactos: [];
//     Incidencias: [];
//     Comentarios: ComentarioModel[];
//     Archivos: [];

//     constructor(data: any) {
//         if (data) {
//             this.IdTicket = data.IdTicket;
//             this.TipoIngreso = data.TipoIngreso;
//             this.IdEstado = data.IdEstado;
//             this.IdLinea = data.IdLinea;
//             this.LineaNegocioAbreviado = data.LineaNegocioAbreviado;
//             this.IdPrioridad = data.IdPrioridad;
//             this.Asunto = data.Asunto;
//             this.IdCliente = data.IdCliente;
//             // this.ClienteNumDoc = data.ClienteNumDoc;
//             // this.ClienteCodCipsa = data.ClienteCodCipsa;
//             // this.RazonSocial = data.RazonSocial;
//             // this.IdContacto = data.IdContacto;
//             // this.TipoContacto = data.TipoContacto;
//             // this.Nombre = data.Nombre;
//             // this.Cargo = data.Cargo;
//             // this.Area = data.Area;
//             // this.Email = data.Email;
//             // this.Telf = data.Telf;
//             // this.Anexo = data.Anexo;
//             this.IdPersonalDerivado = data.IdPersonalDerivado;
//             this.PersonalDerivado = data.PersonalDerivado;
//             this.PerDerivadoPuesto = data.PerDerivadoPuesto;
//             this.TiempoTranscurrido = data.TiempoTranscurrido;
//             // this.IdPersonalSolicitante = data.IdPersonalSolicitante;
//             // this.PersonalSolicitante = data.PersonalSolicitante;
//             // this.ProximaAlerta = data.ProximaAlerta;
//             // this.AnotacionInterna = data.AnotacionInterna;
//             // this.IdBolsaTiempo = data.IdBolsaTiempo;
//             // this.Horas = data.Horas;
//             // this.TiempoEfectivo = data.TiempoEfectivo;
//             // this.VigenciaFin = data.VigenciaFin;
//             // this.Motivo = data.Motivo;
//             // this.Factura = data.Factura;
//             // this.IdPersonalRegistro = data.IdPersonalRegistro;
//             // this.PersonalRegistro = data.PersonalRegistro;
//             this.FechaRegistro = data.FechaRegistro;
//             this.FlagRequerimiento = data.FlagRequerimiento;
//             this.Calificacion = data.Calificacion;
//             this.CalificacionObs = data.CalificacionObs;

//             this.Contactos = data.Contactos;
//             this.Incidencias = data.Incidencias;
//             this.Comentarios = data.Comentarios.map((item: any) => new ComentarioModel(item));
//             this.Archivos = data.Archivos;
//         }
//     }
// }